import {
  HttpBackend,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Inject, Injectable, NgZone } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';
import { Serializer } from '../../../helpers/serializer/seriealizer';
import { Utils } from '../../../utils/utils';
import { SessionService } from './../../../services/session.service';
import {
  TECH_LIB_PORTAL_CONFIG,
  TechLibPortalConfig,
} from '../../../tech-lib-portal.interceptor';
import { ServicesModelModel } from '../response/models/servicesmodel.model';
import { ServicesModelInterface } from '../response/interfaces/servicesmodel.interface';
import { PortfoliosEnum } from '../../../services/api-names';
import { ClientPortfolioModel } from '../response/models/clientportfolio.model';
import { ClientPortfolioInterface } from '../response/interfaces/clientportfolio.interface';

@Injectable({
  providedIn: 'root',
})
export class PortfolioService {
  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private httpClient: HttpClient,
    private serializer: Serializer,
    private session: SessionService,
    private zone: NgZone
  ) {}

  private updateSession() {
    this.config.sessionToken = this.session.sessionToken;
    this.config.domain = this.session.domain;
    this.config.clientCode = this.session.clientCode;
    this.config.language = this.session.language;
  }

  public getServiceModel(): Observable<ServicesModelInterface[]> {
    const url =
      this.config.baseApi + PortfoliosEnum.api_portal_client_servicemodel;

    this.updateSession();

    return new Observable((observer: Observer<ServicesModelModel[]>) => {
      this.httpClient
        .get<ServicesModelInterface[]>(url)
        .pipe(
          map((resp: any) => {
            return resp as ServicesModelModel[];
          })
        )
        .subscribe(
          (resp: any) => {
            observer.next(resp);
            observer.complete();
          },
          (err) => observer.error(err)
        );
    });
  }

  public clientPortfolio(
    codservicemodel: string
  ): Observable<ClientPortfolioInterface> {
    const url =
      this.config.baseApi + PortfoliosEnum.api_onboarding_client_portfolio;
    const body = { ServiceModelCode: codservicemodel };

    this.updateSession();

    return new Observable((observer: Observer<ClientPortfolioModel>) => {
      this.httpClient
        .post<ClientPortfolioInterface>(url, body)
        .pipe(
          map((resp: any) => {
            return resp;
          })
        )
        .subscribe(
          (resp: ClientPortfolioModel) => {
            observer.next(resp);
            observer.complete();
          },
          (err) => observer.error(err)
        );
    });
  }
}
